<script>
export default {
  name: 'MultipleTime',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [Object],
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    event: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'small',
    },
    props: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    selectHandler: {
      type: Function,
      default: () => () => {},
    },
  },
  computed: {
    placeholder() {
      let el = this.options.find((f) => f.value === this.value.key)
      return (
        (el && el.placeholder) ||
        `请输入${el?.label === '全部' ? '关键词' : el?.label || ''}`
      )
    },
    dateType: function () {
      if (this.value.key && this.options.length > 0) {
        let el = this.options.find((f) => f.value === this.value.key)
        if (el && el.dateType) {
          return el.dateType
        }
      }
      return 'daterange'
    },
  },
  data() {
    return {
      resizeObserver: null,
    }
  },
  created() {
    this.$set(this.value, 'key', this.value?.key || '')

    if (this.dateType.includes('range')) {
      this.$set(this.value, 'value', this.value?.value || [])
    } else {
      this.$set(this.value, 'value', this.value?.value || '')
    }
  },
  methods: {
    generateSelect() {
      return (
        <el-select
          ref="mySelect"
          v-model={this.value.key}
          on={{ change: this.handleChange, clear: this.handleClear }}
          size={this.size}
          style="width: 120px"
        >
          {this.options.map((m) => {
            return <el-option props={{ ...m }}></el-option>
          })}
        </el-select>
      )
    },
    generateBtn() {
      return (
        <span class="search" onClick={this.handleBtnClick}>
          <i class="el-icon-search"></i>
        </span>
      )
    },
    handleInput(val) {
      //   this.$emit('input', this.value)
    },
    handleChange(val) {
      this.value.key = val
      this.value.value = ''
      this?.selectHandler(val)
      //   this.$emit('input', this.value)
    },
    handleClear() {},
    handleBtnClick(event) {
      typeof this.event.keyup === 'function' && this.event.keyup(event, true)
    },
  },
  render(h) {
    let { props, value, dateType, event } = this
    return (
      <div class="select-time">
        {this.generateSelect()}
        <el-date-picker
          v-model={value.value}
          type={dateType}
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder={'请选择'}
          default-time={['00:00:00', '23:59:59']}
          props={props}
          on={event}
        ></el-date-picker>
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
.select-time {
  display: flex;
  align-items: center;
  width: max-content;
  .search {
    margin-left: 10px;
    cursor: pointer;
    font-size: 18px;
  }
  ::v-deep .el-date-editor {
    width: 230px;
    margin-left: 8px;
  }
}
</style>
